<template>

	<div class="col-12 pr-0">

		<transition name="slide">

			<b-card :header="$t('client.transaction')" style="overflow: hidden; margin-right:5px">
				<div slot="header" class="d-flex justify-content-between custom-card-header">
					<span class="card-header-title"> {{ $t('client.clients') }}</span>
					<div class="card-header-actions">
						<div class="searchInCard">
							<b-input-group size="sm">
								<b-form-input v-model="keyword"
											  size="sm"
											  :placeholder="$t('contragent.filter')"
											  autocomplete="off"
											  @input="searchClient"
								/>
								<b-input-group-append>
									<b-button :disabled="!keyword" @click="searchClient('')">{{$t('contragent.clear')}}
									</b-button>
								</b-input-group-append>
							</b-input-group>
						</div>
						<div class="card-header-actions">
							<b-link @click="openCreate()"
									v-if="$can('create/edit', 'customer')"
									class="card-header-action btn-setting"
									style="font-size: 15px">
								<i class="fa fa-plus-circle"></i>
							</b-link>
						</div>

					</div>
				</div>
				<div class="table-responsive table-wrapper">
					<b-table class="generalTableClass" :hover="hover" :striped="striped" :bordered="bordered"
							 :small="small"
							 :fixed="fixed"
							 responsive="sm" :items="clients" :fields="computedFields" :current-page="currentPage"
							 :per-page="0" show-empty>
						<template slot="memberCardDiscount" slot-scope="data">
							<span v-if="data.item.memberCardDiscount">{{ data.item.memberCardDiscount }} %</span>
							<span v-else>0</span>
						</template>
						<template slot="totalBoughtValue" slot-scope="data">
						<span v-if="data.item.totalBoughtValue">{{ data.item.totalBoughtValue | currency({
							symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
							thousandsSeparator: ' '
						})}}</span>
							<span v-else>0</span>
						</template>
						<template slot="gender" slot-scope="data">
							<strong>{{data.item.gender=='MALE'?
								$t('client.create.male'):$t('client.create.female')}} </strong>
						</template>
						<template slot="actions" slot-scope="data">


							<b-link :key="data.item.id + 'delete'"
									@click="onOpen(data.item.id)"
									:id="'popOverDelete'+data.item.id"
									v-if="$can('delete', 'employee')">
								<i class="fa fa-trash"></i>
							</b-link>

							<b-link @click="updateClientOpenModal(data.item)" v-b-tooltip.hover
							>
								<i class="fa fa-edit"></i>
							</b-link>

							<b-popover
								:key="data.item.id + 'popover'"
								:target="'popOverDelete'+data.item.id"
								placement="auto"
								container="myContainer"
								:ref="'popover'+data.item.id"
								class="refDeleteConfirm"
							>
								<template slot="title">
									<b-button @click="onClose(data.item.id)" class="close"
											  aria-label="Close"
											  style="margin-left: 5px">
										<span class="d-inline-block" aria-hidden="true">&times;</span>
									</b-button>
									{{$t('actions.deletetitle')}}
								</template>
								<div>

									<div class="row mt-1">
										<div class="col-6">
											<b-button variant="outline-danger" size="sm" block
													  @click="onClose(data.item.id)">{{$t('actions.no')}}
											</b-button>
										</div>
										<div class="col-6">
											<b-button variant="outline-success" size="sm" block
													  @click="onOk(data.item.id)">{{$t('actions.yes')}}
											</b-button>
										</div>
									</div>
								</div>
							</b-popover>


						</template>


					</b-table>
					<nav>
						<b-pagination size="sm" :total-rows="total" :per-page="perPage"
									  v-model="currentPage" :prev-text="$t('pagination.prev')" :next-text="$t('pagination.next')" hide-goto-end-buttons
						/>
					</nav>
					<div v-if="this.loadingClient" class="spinner-wrapper">
						<b-spinner variant="primary"></b-spinner>
					</div>
				</div>
				<vs-sidebar :click-not-close="true" position-right parent="body" default-index="1" color="primary"
							class="create-modal" spacer v-model="createModal">
					<b-container index="1" v-if="createModal">
						<CreateClientModal
							@not-close="closable = $event"
							@close="close"
							:mode="mode"
						></CreateClientModal>
					</b-container>
				</vs-sidebar>

			</b-card>
		</transition>
	</div>
</template>

<script>
	import CreateClientModal from "./CreateClientModal";
	import {mapGetters, mapActions, mapState} from 'vuex'
	import ClientService from "../../services/client.service";

	export default {
		name: "ClientTable",

		props: {
			caption: {
				type: String,
				default: 'Employees'
			},
			hover: {
				type: Boolean,
				default: true
			},
			striped: {
				type: Boolean,
				default: true
			},
			bordered: {
				type: Boolean,
				default: false
			},
			small: {
				type: Boolean,
				default: false
			},
			fixed: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				keyword: '',
				createModal: false,
				items: [],
				mode: 'update',
				currentPage: 1,
				perPage: 20,
				search: {
					page: 1,
					limit: 50,
					attributes: [
						{
							field: 'lastName',
							value: '',
							option: 'CONTAINS'
						},

					]
				}
			}
		},
		methods: {
			searchClient($event) {
				if ($event != "") {
					ClientService.searchLastName($event).then(response => {
						let searchRes = response.data;

						this.$store.commit('clients/searchLastNameStore', searchRes);
					})
				} else {
					ClientService.getAllClient(this.search).then(response => {
						let searchRes = response.data.items;
						this.$store.commit('clients/searchLastNameStore', searchRes);
						this.keyword = '';
					});
				}
			},

			...mapActions('clients', [
				'getAllClientsForTable', 'deleteCLientStore', 'currentUpdateForClient'
			]),
			onOpen(itemId) {
				let refName = 'popover' + itemId;
				this.$refs[refName].$emit('open')
			},
			cancel() {
				this.$emit('close', true);
			},
			close() {
				this.createModal = false;
				this.mode = 'update';
				this.item = null;
			},

			onClose(itemId) {
				let refName = 'popover' + itemId;
				this.$refs[refName].$emit('close')
			},
			async onOk(itemId) {
				this.onClose(itemId)
				await this.clientDelete(itemId);
			},
			async clientDelete(id) {
				await this.deleteCLientStore(id);
				let paramsForClient = {
					page: this.currentPage,
					limit: this.perPage
				};
				await this.getAllClientsForTable(paramsForClient);

			},
			updateClientOpenModal(item) {
				this.currentUpdateForClient(item);
				this.createModal = true

			},
			openCreate() {
				this.createModal = true
				this.mode = "create"
			},

		},


		async mounted() {
			let paramsForClient = {
				page: this.currentPage,
				limit: this.perPage
			};
			await this.getAllClientsForTable(paramsForClient);

		},

		watch: {
			currentPage: {
				handler() {
					let paramsForClient = {
						page: this.currentPage,
						limit: this.perPage
					}
					this.getAllClientsForTable(paramsForClient)
				}
			},
			// clients: {
			// 	handler() {
			// 		let paramsForClient = {
			// 			page: this.currentPage,
			// 			limit: this.perPage
			// 		};
			// 		if (this.clients.length < 1) {
			// 			this.getAllClientsForTable(paramsForClient)
			// 		}
			// 	}
			// }
		},


		computed: {
            ...mapState(['userDepCurrencyName']),
			...mapState('clients', [
				'loadingClient'
			]),
			...mapState('clients', [
				'total'
			]),
			computedFields() {
				return [
					{
						key: 'id',
						label: this.$t('users-l.Id'),
						'class': 'role_id',
					},
					{
						key: 'firstName',
						label: this.$t('client.create.first-name')

					},
					{
						key: 'lastName',
						label: this.$t('client.create.last-name')

					},

					{
						key: 'memberCard',
						label: this.$t('client.cart')
					},
					{
						key: 'memberCardDiscount',
						label:  this.$t('promo-to-product.promo')
					},

					{
						key: 'totalBoughtValue',
						label: this.$t('client.get-sale')
					},
					{
						key: 'phone',
						label: this.$t('client.create.mobile')
					},
					{
						key: 'gender',
						label: this.$t('client.create.gender')
					},

					{
						key: 'actions',
						label: this.$t('actions.title'),
						'class': 'table_actions'

					},

				]
			},
			...mapGetters('clients', [
				'clients', 'columns'
			]),
		},

		components: {
			CreateClientModal,


		}


	}
</script>

<style scoped>
	.spinner-wrapper {
		position: absolute;
		background: rgba(32, 28, 32, 0.49);
		left: 0;
		right: 0;
		text-align: center;
		top: 0;
		bottom: 0;
		padding-top: 35px;
		z-index: 5;
	}

	.table-wrapper {
		position: relative;
		padding: 5px;
	}
</style>
